import { atMapsToGeojson } from '@alltrails/maps/utils/legacyGeoJSONConversions';
import { getTrailContribVRs } from '../../requests/trail_requests';
import { addPolylines, removePolylines } from './polylines';

const contribsId = 'contribs';

const addContribs = (map, trailId) => {
  getTrailContribVRs(trailId).then(maps => {
    const geojson = atMapsToGeojson(maps);
    const lineOpts = { 'line-color': '#0B0', 'line-opacity': 0.3, 'line-width': 12 };
    addPolylines(map, contribsId, geojson, {} /* sourceOpts */, lineOpts, ['circle', 'symbol', 'line']);
  });
};

const removeContribs = map => {
  removePolylines(map, contribsId);
};

export { addContribs, removeContribs };
